import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Form as RsForm } from 'reactstrap';
import { Formik, Form as FForm } from 'formik';

var Form = function Form(_ref) {
  var initialValues = _ref.initialValues,
      onSubmit = _ref.onSubmit,
      initialStatus = _ref.initialStatus,
      initialErrors = _ref.initialErrors,
      initialTouched = _ref.initialTouched,
      onReset = _ref.onReset,
      validationSchema = _ref.validationSchema,
      validate = _ref.validate,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["initialValues", "onSubmit", "initialStatus", "initialErrors", "initialTouched", "onReset", "validationSchema", "validate", "children"]);

  return React.createElement(Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    onReset: onReset,
    initialStatus: initialStatus,
    initialErrors: initialErrors,
    initialTouched: initialTouched,
    validationSchema: validationSchema,
    validate: validate
  }, React.createElement(RsForm, Object.assign({
    "data-testid": "form-container",
    tag: FForm
  }, rest), children));
};

Form.defaultProps = {
  onSubmit: function onSubmit() {}
};
export default Form;